import { render } from "./forgot.vue?vue&type=template&id=90f72006&scoped=true"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"

import "./forgot.vue?vue&type=style&index=0&id=90f72006&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90f72006"]])

export default __exports__